import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";
import { getShifts, changeStatus } from "../../../core/data/redux/shiftVerificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { toCamelCase } from "../../../core/hooks/commonFunctions";
import ChangeStatusModal from "../../../core/modals/changeStatusModal";
import ModalPortal from "../../../core/modals/ModalPortal";
import ApproveModal from "../../../core/modals/approveModal";
import RejectModal from "../../../core/modals/rejectModal";
interface ShiftVerificationTableProps {
    type: string

}

const ShiftVerificationTable = (props: ShiftVerificationTableProps) => {

    const { type } = props;
    const dispatch = useDispatch();
    const shiftVerificationState = useSelector((state: any) => state.shiftVerificationState);
    const [dataList, setDataList] = React.useState<any[]>([]);
    const [currentItem, setCurrentItem] = React.useState<any>(null);
    const [status, setStatus] = React.useState<any>(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10
    });

    const fetchRecords = () => {
        dispatch(getShifts({ page: pagination.current, limit: pagination.pageSize, is_verified: type }));
    }

    React.useEffect(() => {
        fetchRecords();
    }, [type]);

    React.useEffect(() => {
        if (shiftVerificationState.loading === "fulfilled" && shiftVerificationState.action === "update") {
            fetchRecords();
        }
        else if (shiftVerificationState.loading === "fulfilled" && shiftVerificationState.action === "list") {
            const result = shiftVerificationState?.data?.data || null;


            if (result.data && result.data.length > 0) {
                const employees = result?.data || [];
                setDataList(employees);
                setPagination({
                    ...pagination,
                    total: result.total || employees.length,
                    current: result.page || 1,
                    pageSize: result.limit || 10
                });
            } else {
                setDataList([]);
            }
        }
    }, [shiftVerificationState.loading]);

    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            width: 100,
            render: (text: string, record: any, index: number) => (
                <>
                    <div>
                        {(pagination.current) ? (index + pagination.current * pagination.pageSize - pagination.pageSize + 1) : (index + 1)}
                    </div>
                </>
            ),
            //sorter: (a: any, b: any) => a.id.length - b.id.length,
        },
        {
            title: "Employee Name",
            dataIndex: "employee",
            //sorter: (a: any, b: any) => a.employee.first_name.length - b.employee.first_name.length,
            render: (employee: any) => `${employee?.details?.firstname}` || '',
        },

        {
            title: "Shift Name",
            dataIndex: "work_shift",
            //sorter: (a: any, b: any) => a.employee.first_name.length - b.employee.first_name.length,
            render: (work_shift: any) => `${work_shift?.shift_name}` || '',
        },
        {
            title: "Shift Start Time",
            dataIndex: "work_shift",
            //sorter: (a: any, b: any) => a.employee.first_name.length - b.employee.first_name.length,
            render: (work_shift: any) => `${work_shift?.start_time}` || '',
        },
        {
            title: "Shift End Time",
            dataIndex: "work_shift",
            //sorter: (a: any, b: any) => a.employee.first_name.length - b.employee.first_name.length,
            render: (work_shift: any) => `${work_shift?.end_time}` || '',
        },

        {
            title: "Is Verified",
            dataIndex: "is_verified",
            sorter: (a: any, b: any) => a.is_verified.length - b.is_verified.length,
            render: (is_verified: any) => {
                return (
                    <span className={`badge ${(is_verified === 'VERIFIED') ? 'badge-success' : (is_verified === 'REJECTED') ? 'badge-danger' : 'badge-info'} d-inline-flex align-items-center badge-xs`}>
                        {is_verified}
                    </span>
                )
            },
        },
        {
            title: "Actions",
            dataIndex: "actions",
            width: 100,
            render: (text: string, record: any, index: number) => (
                <div className="action-icon d-inline-flex gap-2">
                    <button className="btn btn-primary btn-sm" data-bs-toggle="modal" data-inert={true} data-bs-target="#reject_modal"
                        onClick={() => handleClick(record)}>
                        Reject
                    </button>
                    <button className="btn btn-success btn-sm" data-bs-toggle="modal" data-inert={true} data-bs-target="#approve_modal"
                        onClick={() => handleClick(record)}>
                        Approve
                    </button>
                </div>
            ),
        }
    ];

    const handleClick = (record: any) => {
        setCurrentItem(record);
    }

    const handlePagination = (pagination: any) => {
        setPagination({
            current: pagination.page,
            pageSize: pagination.pageSize,
            total: pagination.total || 10
        });
        fetchRecords();
    };

    const handleChangeStatus = async (response: string, status: string) => {
        alert('Hii')
    }


    return (
        <div>
            <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                    <h4 className="mb-4 mt-3">{toCamelCase(type)} Shift Requests</h4>
                </div>
                <div className="card-body p-0 py-3">
                    <Table
                        columns={columns}
                        dataSource={dataList}
                        Selection={false}
                        paginationConfig={pagination}
                        handlePagination={handlePagination}
                        loading={shiftVerificationState.loading === "pending"}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-md-12">
                    <div className="datatable-paginate mt-4" />
                </div>
            </div>
            <ModalPortal>
                <RejectModal handleChangeStatus={(res: any) => handleChangeStatus(res, 'REJECTED')} />
                <ApproveModal handleChangeStatus={(res: any) => handleChangeStatus(res, 'VERIFIED')} />
            </ModalPortal>
        </div>
    );
}

export default ShiftVerificationTable; 